import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { deleteParts, editParts, getParts, updateParts } from '../partsThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'parts';

export const partsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getParts });
        handleRequestThunk({ builder, request: deleteParts, isDelete: true });
        handleRequestThunk({ builder, request: editParts });
        handleRequestThunk({ builder, request: updateParts });
    },
});

export const parts = partsSlice.reducer;
